// @mui
import { GlobalStyles as MUIGlobalStyles } from '@mui/material';

// ----------------------------------------------------------------------

export default function GlobalStyles() {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        ul: {
          margin: 0,
          padding: 0,
        },
        // Calendar event colors by booking status
        '[data-calendar-id="approved"] .toastui-calendar-weekday-event': {
          backgroundColor: 'rgba(54, 179, 126, 0.16) !important',
          borderLeft: '3px solid #007B55 !important',
        },
        '[data-calendar-id="pending"] .toastui-calendar-weekday-event': {
          backgroundColor: 'rgba(255, 171, 0, 0.16) !important',
          borderLeft: '3px solid rgb(183, 110, 0) !important',
        },
      }}
    />
  );

  return inputGlobalStyles;
}
